/**
 * Thank-you flow: shared route state for full-page routes and modal overlay.
 * Buy: ThankForContactingApartments. Rent: RentsThankForContactingApartments.
 */

export function buildThankYouRouteState({
  leadData,
  searchLocation,
  searchCity,
  contactedLocation,
  contactedSlug,
  remainingData,
  displayTitle,
}) {
  if (!leadData) return null;
  return {
    leadData,
    ...(searchLocation ? { searchLocation } : {}),
    ...(searchCity ? { searchCity } : {}),
    ...(contactedLocation ? { contactedLocation } : {}),
    ...(contactedSlug ? { contactedSlug } : {}),
    ...(remainingData ? { remainingData } : {}),
    ...(displayTitle ? { displayTitle } : {}),
  };
}

export function getBuyThankYouPath(listingKind) {
  const k = String(listingKind ?? 'apartment').toLowerCase();
  if (k.includes('villa')) return '/villas-thank-for-contacting-apartments';
  if (k.includes('plot')) return '/plots-thank-for-contacting-apartments';
  return '/apts-thank-for-contacting-apartments';
}

/** Full-page navigation (legacy / bookmarks). Prefer ThankYouModalContext for in-app submits. */
export function navigateAfterWebLeadSubmit(
  navigate,
  {
    leadData,
    listingType = 'apartment',
    isRentListing = false,
    searchLocation,
    searchCity,
    contactedLocation,
    contactedSlug,
    remainingData,
    displayTitle,
  },
) {
  if (!leadData || typeof navigate !== 'function') return;

  const state = buildThankYouRouteState({
    leadData,
    searchLocation,
    searchCity,
    contactedLocation,
    contactedSlug,
    remainingData,
    displayTitle,
  });
  if (!state) return;

  const path = isRentListing ? '/rents-thank-for-contacting-apartments' : getBuyThankYouPath(listingType);
  navigate(path, { state });
}

/**
 * @param {object} opts — same fields as navigateAfterWebLeadSubmit (without navigate)
 * @returns {{ routeState: object, listingType: string, isRentListing: boolean } | null}
 */
export function openThankYouAfterSubmitPayload({
  leadData,
  listingType = 'apartment',
  isRentListing = false,
  searchLocation,
  searchCity,
  contactedLocation,
  contactedSlug,
  remainingData,
  displayTitle,
}) {
  const routeState = buildThankYouRouteState({
    leadData,
    searchLocation,
    searchCity,
    contactedLocation,
    contactedSlug,
    remainingData,
    displayTitle,
  });
  if (!routeState) return null;
  return {
    routeState,
    listingType: String(listingType ?? 'apartment').toLowerCase().includes('villa')
      ? 'villa'
      : String(listingType ?? 'apartment').toLowerCase().includes('plot')
        ? 'plot'
        : 'apartment',
    isRentListing: Boolean(isRentListing),
  };
}
